import { FONT_FAMILY_BROWN_WITH_FALLBACKS } from '../../../../fonts';
import { LABELS_FILL_COLOR, SEPARATOR_COLOR } from '../../../theme/colors';
import { FTV_TIMING_FUNCTION_IN } from '../../../theme/constants';

export const SLIDE_WRAPPER_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  transitionTimingFunction: FTV_TIMING_FUNCTION_IN,
  transitionProperty: 'all',
  width: '100%'
};

export const NAV_BAR_STYLES = {
  default: {
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS,
    fontWeight: 700,
    display: 'grid',
    position: 'relative',
    marginBottom: 10,
    marginLeft: 12,
    justifyItems: 'start'
  }
};

export const NAV_BAR_TITLE_STYLES = {
  default: {
    display: 'flex',
    alignItems: 'center',
    transition: `all .32s ${FTV_TIMING_FUNCTION_IN}`,
    gridArea: '1/1'
  }
};

export const SLIDE_MENU_ITEMS_SPACING = {
  padding: '6px 12px'
};

export const SELECTABLE_ITEM_STYLE = {
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS,
  fontWeight: 400,
  ...SLIDE_MENU_ITEMS_SPACING
};

export const ROW_ITEM_STYLE = {
  ...SELECTABLE_ITEM_STYLE,
  ...SLIDE_MENU_ITEMS_SPACING
};

export const ROW_ITEM_LABEL_STYLE = {
  maxWidth: '65%',
  whiteSpace: 'nowrap'
};

export const ROW_ITEM_SUBLABEL_STYLE = {
  fontSize: '100%',
  color: LABELS_FILL_COLOR,
  display: 'flex',
  alignItems: 'center'
};

export const ACTIVE_BULLET_STYLE = {
  default: {
    height: 6,
    width: 6,
    backgroundColor: LABELS_FILL_COLOR,
    flexShrink: 0,
    borderRadius: 10
  },
  extraSmall: {
    width: 4,
    height: 4
  }
};

export const SELECTABLE_DESCRIPTION_STYLES = {
  default: {
    lineHeight: '1.2',
    marginTop: 2,
    color: LABELS_FILL_COLOR
  }
};

export const SEPARATOR_STYLE = {
  default: {
    backgroundColor: SEPARATOR_COLOR,
    height: 0.9,
    marginTop: 6,
    marginBottom: 6,
    marginRight: 22,
    marginLeft: 10
  },
  extraSmall: { marginRight: 12 }
};

export const CONTENT_FLEX_WITH_GAP = {
  display: 'flex', flexDirection: 'column'
};
